
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, signal, ViewChildren, ElementRef, QueryList, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { gsap } from 'gsap';
import { CategoriesGralService } from './service/categories-gral.service';
import { CategorieGralData, CategorieGralResponse } from './interface/caregorie-gral.interface';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Router } from '@angular/router';
import { TypeEatBarService } from '../type-eat-bar/service/type-eat-bar.service';
import { ErrorMessageComponent } from "../error-message/error-message.component";

@Component({
  selector: 'shared-categories-gral',
  imports: [NgxSkeletonLoaderModule, ErrorMessageComponent],
  templateUrl: './categories-gral.component.html',
  styleUrl: './categories-gral.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesGralComponent implements OnInit {
  isLoading = signal(true);
  hasError = signal(false);
  currentSlide = signal(0);
  categoriesGral = signal<CategorieGralData[]>([])
  activeCategoryId = signal<number | null>(null);
  @ViewChildren('catImage') catImages!: QueryList<ElementRef<HTMLImageElement>>;
  @ViewChildren('cardItem') cardItems!: QueryList<ElementRef<HTMLDivElement>>;
  constructor(private CategoriesGralService: CategoriesGralService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public typeEatBarService: TypeEatBarService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }

  ngOnInit(): void {
    this.loadCategiriesGral();
  }



  loadCategiriesGral(): void {
    this.isLoading.set(true);
    this.hasError.set(false);

    this.CategoriesGralService.loadCategoriesGral().subscribe({
      next: (response: CategorieGralResponse) => {
        if (response && response.data && response.data.length > 0) {
          this.categoriesGral.set(response.data);
          this.cdr.markForCheck();
        } else {
          this.hasError.set(true);
        }
        this.isLoading.set(false);
        // Animar entrada de cards cuando el skeleton termina
        setTimeout(() => this.animateCardsIn(), 0);
      },
      error: (error) => {
        console.error('Error loading categories:', error);
        this.hasError.set(true);
        this.isLoading.set(false);
      }
    })
  }
  nextSlide(): void {
    if (this.currentSlide() < this.categoriesGral().length - 1) {
      this.currentSlide.update((value) => value + 1);
    }
  }
  prevSlide(): void {
    if (this.currentSlide() > 0) {
      this.currentSlide.update((value) => value - 1);
    }
  }
  navigateEstablishmentForCategorie(categorie_id: number): void {
    this.activeCategoryId.set(categorie_id);
    this.router.navigate(['/establishment-section-gral', categorie_id]);
  }

  isActiveCategory(categoryId: number): boolean {
    return this.activeCategoryId() === categoryId;
  }

  onCardEnter(index: number): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const imgEl = this.catImages?.toArray()[index]?.nativeElement;
    const cardEl = this.cardItems?.toArray()[index]?.nativeElement;
    if (imgEl) {
      gsap.set(imgEl, { willChange: 'transform' });
      gsap.to(imgEl, { rotate: 12, duration: 0.4, ease: 'power2.out', transformOrigin: '50% 50%' });
    }
    if (cardEl) {
      gsap.set(cardEl, { willChange: 'transform, box-shadow' });
      gsap.to(cardEl, { y: -8, scale: 1.02, duration: 0.35, ease: 'power2.out' });
    }
  }

  onCardLeave(index: number): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const imgEl = this.catImages?.toArray()[index]?.nativeElement;
    const cardEl = this.cardItems?.toArray()[index]?.nativeElement;
    if (imgEl) {
      gsap.to(imgEl, { rotate: 0, duration: 0.4, ease: 'power2.inOut' });
    }
    if (cardEl) {
      gsap.to(cardEl, { y: 0, scale: 1, duration: 0.35, ease: 'power2.inOut' });
    }
  }

  private animateCardsIn(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const elements = this.cardItems?.toArray().map(ref => ref.nativeElement) ?? [];
    if (!elements.length) return;
    gsap.set(elements, { willChange: 'transform, opacity' });
    gsap.from(elements, {
      y: 90,
      opacity: 0,
      duration: 0.9,
      ease: 'power3.out',
      stagger: 0.08
    });
  }
}
